// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import BillingModalGenericBlocker from './BillingModalGenericBlocker'
import { isSeparatelyInvoiced, isOwner } from '../../../utils/subscriptionUtils';
import { useSubscription } from '../../../hooks/subscriptions/queries';
import { useCurrentUser } from '../../../hooks/users/queries';

const getText = (isSubscriptionOwner, isSeparatelyInvoiced) => {
  if (isSeparatelyInvoiced) {
    if (isSubscriptionOwner) {
      return "Your Delve subscription has expired. Please contact the Delve team to renew it."
    } else {
      return "Your Delve subscription has expired. Contact your team owner to renew it, or start your own subscription."
    }
  } else {
    if (isSubscriptionOwner) {
      return "Please renew your subscription to access this project.";
    } else {
      return "Please start your subscription to access this project."
    }
  }
}

function BillingModalBlocker({ onClick }) {
  const { data: subscription } = useSubscription();
  const { data: currentUser } = useCurrentUser();
  const isSubscriptionOwner = isOwner(subscription, currentUser?.id);
  const separatelyInvoiced = isSeparatelyInvoiced(subscription);
  const text = getText(isSubscriptionOwner, separatelyInvoiced);

  return (
    <BillingModalGenericBlocker
      onClick={separatelyInvoiced ? null : onClick}
      text={text}
      header="Delve Subscription Required"
      isSubscriptionOwner={isSubscriptionOwner}
    />
  );
}

export default BillingModalBlocker;
